
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("5FomD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a62885bf2499ce3e3ae53a4060ebf5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4203ae4a14ed11e6$var$_react = $4203ae4a14ed11e6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4203ae4a14ed11e6$var$_baseNew = $4203ae4a14ed11e6$var$_interopRequireDefault((parcelRequire("3b3Iv")));
function $4203ae4a14ed11e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-locked
 * Usage guidance:
 * Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4203ae4a14ed11e6$var$LockLockedIcon = (props)=>/*#__PURE__*/ $4203ae4a14ed11e6$var$_react.default.createElement($4203ae4a14ed11e6$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$4203ae4a14ed11e6$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $4203ae4a14ed11e6$var$_default = module.exports.default = $4203ae4a14ed11e6$var$LockLockedIcon;

});


//# sourceMappingURL=@atlaskit-internal_forge-icons--switcher.bf7b1742.js.map
